function PrettyLocalDateTime(props) {
  if (props.date == null) return <span className="color-dull">N/A</span>;

  let date = new Date(props.date),
    { hideTime, className } = props,
    zeroPaddedMinutes = date.getMinutes();

  if (zeroPaddedMinutes < 10) zeroPaddedMinutes = `0${zeroPaddedMinutes}`;

  return (
    <span className={className}>
      {date.toLocaleDateString()}
      {hideTime ? null : (
        <small className="color-dull ml-1">
          {date.getHours()}:{zeroPaddedMinutes}
        </small>
      )}
    </span>
  );
}

export default PrettyLocalDateTime;
